import React from "react";
import moment from 'moment';

export function DateNormalColumnFormatter(cellContent) {

  return (
    <div className="d-flex justify-content-start">
      <span className="text-dark-75 d-block text-nowrap">
       {cellContent ? moment(cellContent).format('DD-MM-YYYY') : ''}
      </span>
    </div>
  );
}
